import dayjs = require("dayjs");
import { logger } from "../../../utilities/logger";
import { SharePointInputTypes } from "../config/sharepointConstants";
import { IMappedValue } from "./EmailMapper";

export class DefaultValueService {
  static setValue(type: string, value: any) {
    try {
      if (value && (type === SharePointInputTypes.taxonomyFieldType || type === SharePointInputTypes.taxonomyFieldTypeMulti)) { // will be extended for future issues
        const defaultValues: string[] = [];
        const defaultsRaw = value.split(";#");
        for (let index = 0; index < defaultsRaw.length; index++) {
          const element = defaultsRaw[index] as string;
          if (element.indexOf("|") !== -1) {
            const valueSection = element.split("|");
            if (valueSection.length > 0) {
              defaultValues.push(valueSection[0]);
            }
          }
        }
        return defaultValues;
      }
    } catch (error) {
      logger(error, "DefaultValueService.ts (setValue)");
    }

    return value;
  }

  static setMappedDefault(input: any, mappedValue: IMappedValue) {
    if (!mappedValue?.value) {
      return null;
    }

    try {
      const inputType = input.xml?.Type?.toLowerCase();
      if (inputType == SharePointInputTypes.text.toLowerCase() || inputType == SharePointInputTypes.note.toLowerCase()) {

        if (Array.isArray(mappedValue.value)) {
          return mappedValue.value.join(", ");
        }
        return mappedValue.value;

      } else if (inputType == SharePointInputTypes.choice.toLowerCase() || inputType == SharePointInputTypes.multiChoice.toLowerCase()) {

        if (Array.isArray(input.choices)) {
          let choiceValue: any;
          if (Array.isArray(mappedValue.value)) {
            const mappedDefaults: string[] = mappedValue.value as string[];
            if (mappedDefaults) {
              choiceValue = input.choices.find(choice => mappedDefaults.some(mappedDefault => choice.toLowerCase().trim() === mappedDefault.toLowerCase().trim()));
            }
          }
          else {
            choiceValue = input.choices.find(choice => choice.toLowerCase().trim() === mappedValue.value.toString().toLowerCase().trim());
          }
          if (choiceValue) return choiceValue;
        }

      } else if (inputType == SharePointInputTypes.number.toLowerCase() || inputType == SharePointInputTypes.currency.toLowerCase()) {

        if (!Array.isArray(mappedValue.value)) {
          let numberValue: number = Number(mappedValue.value);
          if (numberValue) {
            if (input.xml?.Min && numberValue < input.xml.Min) {
              return null;
            }
            if (input.xml?.Max && numberValue > input.xml.Max) {
              return null;
            }
            if (input.xml?.Percentage === "TRUE") {
              return numberValue * 100;
            }
            return numberValue;
          }
        }

      } else if (inputType == SharePointInputTypes.datetime.toLowerCase()) {

        if (!Array.isArray(mappedValue.value)) {
          return dayjs(mappedValue.value).isValid() ? dayjs(mappedValue.value).toDate() : null;
        }

      } else if (inputType == SharePointInputTypes.Boolean.toLowerCase()) {

        if (!Array.isArray(mappedValue.value)) {
          switch (mappedValue.value.toString().toLowerCase().trim()) {
            case "true":
              return true;
            case "false":
              return false;
            case "yes":
              return true;
            case "no":
              return false;
            case "ja":
              return true;
            case "nee":
              return false;
            default:
              return null;
          }
        }

      }
    } catch (error) {
      logger(error, "DefaultValueService.ts (setMappedDefault)");
    }

    return null;
  }
}